import { createContext } from 'react'
import noop from 'lib/function/noop'

type LuxPlusLandingNonMemberTab = 'about' | 'benefits' | 'partner-offers'
type LuxPlusLandingMemberTab = 'best-offers' | 'partner-offers' | 'all-benefits'

interface LuxPlusLandingNavigationContextValue {
  navigateToPartnerOffers: () => void
  registerFilterCategories: (carouselId: string, categories: Array<string>) => void
  scrollOffset: number
}

const LuxPlusLandingNavigationContext = createContext<LuxPlusLandingNavigationContextValue>({
  navigateToPartnerOffers: noop,
  registerFilterCategories: noop,
  scrollOffset: 0,
})

/** Extracts only the no-arg action keys from the navigation context value interface to represent the navigation actions */
type LuxPlusLandingNavigationAction = {
  [K in keyof LuxPlusLandingNavigationContextValue]: LuxPlusLandingNavigationContextValue[K] extends () => void ? K : never
}[keyof LuxPlusLandingNavigationContextValue]

export type { LuxPlusLandingNonMemberTab, LuxPlusLandingMemberTab, LuxPlusLandingNavigationContextValue, LuxPlusLandingNavigationAction }
export default LuxPlusLandingNavigationContext
